/**
 * Api resource endpoints
 * @todo Add all the api resource endpoints in this file
 */
const apiEndpoints = {
  // Fetch accounts
  accounts: "/accounts",

  // Fetch seeds
  seeds: "/seeds",

  // Fetch users
  users: "/users",

  // Fetch countries
  countries: "/countries",

  // Fetch roles
  roles: "/roles",

  // Fetch customers
  customers: "/customers",
  
  // Fetch Mailbox providers
  mailboxProviders: "/mailbox_providers",

  // Fetch user membership
  memberships: "/memberships",
  
  // Customer owners
  owners: "/owners",

  // Errors
  errors: "/errors",
};

// Creates account
apiEndpoints.createAccount = `${apiEndpoints.accounts}/create`;

// Fetch user membership
apiEndpoints.userMembership = `${apiEndpoints.users}/{{userId}}${apiEndpoints.memberships}`;

export default Object.freeze(apiEndpoints);
